import React from 'react'
import styles from './EventDetails.module.scss'
import Type from '@/component/Primitive/Type'
import Container from '@/component/Primitive/Container'
import Stack from '@/component/Primitive/Stack'
import cx from 'classnames'
import Icon from '@/component/Primitive/Icon'
import Prose from '@/component/Primitive/Prose'
import { array, string, oneOf } from 'prop-types'
import { ButtonGroup, Highlight } from '@/component/Primitive/Events'

export const EventDetails = ({
  details,
  backgroundImage,
  theme,
  variant,
  title,
  description,
  buttonGroup
}) => {
  if (!details) return null
  if (details.length === 0) return null

  const cols = details.length < 4 ? details.length : 4

  return (
    <div
      className={cx(
        styles.EventDetails,
        theme === 'dark' && styles.dark,
        theme === 'grey' && styles.grey,
        details?.length > 4 && styles.forceThreeColumn,
        variant === 'block' && styles.block,
        variant === 'box' && styles.box
      )}
    >
      <Container
        center
        size="wide"
        gutter
        className={styles.EventDetailsContainer}
      >
        <Stack className={styles.EventDetailsInner} gap="medium">
          {title && (
            <Type
              as="h1"
              size={['heading5', 'heading2']}
              weight="regular"
              className={styles.Title}
            >
              <Highlight>{title}</Highlight>
            </Type>
          )}

          {description && (
            <Type size={['body2', 'body2']} className={styles.MainDescription}>
              <Prose
                dangerousHtml={description}
                className={styles.Description}
              />
            </Type>
          )}
          <div className={cx(styles.Grid, styles[`cols-${cols}`])}>
            {details?.map((detail, index) => {
              return (
                <div key={index} className={styles.EventDetail}>
                  <Stack gap="small">
                    <Content {...detail} variant={variant} />
                  </Stack>
                  {!!detail?.buttonGroup?.length && (
                    <ButtonGroup
                      classNames={{ button: styles.Button }}
                      group={detail.buttonGroup}
                    />
                  )}
                </div>
              )
            })}
          </div>
          {!!buttonGroup?.length && (
            <ButtonGroup
              group={buttonGroup}
              className={styles.ButtonGroup}
              theme={theme}
            />
          )}
        </Stack>
      </Container>
      {backgroundImage && (
        <div
          className={styles.EventDetailsImage}
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
      )}
    </div>
  )
}

EventDetails.propTypes = {
  details: array,
  backgroundImage: string,
  theme: string,
  variant: oneOf(['inline', 'block', 'box']),
  title: string,
  description: string,
  buttonGroup: array
}

const Content = ({ title, icon, variant, description }) => {
  return (
    <>
      <div
        className={cx(
          styles.Content,
          variant === 'block' && styles.block,
          variant === 'box' && styles.box
        )}
      >
        {icon && (
          <div className={styles.IconWrapper}>
            <Icon
              className={styles.Icon}
              type={icon}
              width={40}
              height={40}
              kit="bzk"
            />
          </div>
        )}
        <Type
          size={['heading7', 'heading6']}
          weight="medium"
          className={styles.Title}
        >
          {title}
        </Type>
        {variant && variant !== 'inline' && (
          <Type size={['body2', 'body3']}>
            <Prose dangerousHtml={description} className={styles.Description} />
          </Type>
        )}
      </div>
      {(variant === 'inline' || !variant) && (
        <Type size={['body2', 'body3']}>
          <Prose dangerousHtml={description} className={styles.Description} />
        </Type>
      )}
    </>
  )
}

Content.propTypes = {
  title: string,
  icon: string,
  variant: oneOf(['inline', 'block', 'box']),
  description: string
}
